<script>
    import {user} from "../auth/auth"
    import {push} from "svelte-spa-router";

    user.signOut();
    push("/");

</script>

<p> Logging out </p>